import { loader } from 'graphql.macro'

export default function reportsQuery ({ dataLoaders, queryKey }) {
  const [, haulerId] = queryKey

  const reportsSchema = loader('./reports.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(reportsSchema, { haulerId })
}
